module.exports = __webpack_public_path__ + "img/new-ui-pc-clean.fde14445.png";